import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import { Button } from '@/components/ui/button';
import { Laptop, Cloud, Database, Zap, TrendingUp, Calculator, XCircle, Check, Cpu } from 'lucide-react';

const ServiceSection = () => {
  const { t } = useTranslation();
  
  return (
    <section id="service" className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-blue-900">
            {t('businessAppsPage.service.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('businessAppsPage.service.subtitle')}
          </p>
        </div>
        
        <div className="flex flex-col md:flex-row gap-12 items-center max-w-6xl mx-auto">
          <div className="md:w-1/2">
            <div className="bg-blue-600 rounded-xl p-6 md:p-8 text-white h-full flex flex-col">
              <h3 className="text-2xl font-bold mb-4">
                Was wir machen
              </h3>
              <p className="text-blue-100 mb-6 text-lg leading-relaxed">
                {t('businessAppsPage.service.pitch')}
              </p>
              
              <div className="bg-white/10 rounded-lg p-4 mb-4">
                <h4 className="font-semibold mb-2">Für wen?</h4>
                <p>{t('businessAppsPage.service.forWhom')}</p>
              </div>
              
              <div className="bg-white/10 rounded-lg p-4 mt-auto">
                <h4 className="font-semibold mb-2">Warum jetzt?</h4>
                <p>{t('businessAppsPage.service.whyNow')}</p>
              </div>
            </div>
          </div>
          
          <div className="md:w-1/2">
            <div className="bg-gray-50 rounded-xl p-6 md:p-8 border border-gray-200">
              <ul className="space-y-5">
                <li className="flex items-start">
                  <div className="bg-blue-100 p-2 rounded-md mr-4">
                    <Laptop className="h-6 w-6 text-blue-700" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg">Benutzerfreundliche Oberflächen</h4>
                    <p className="text-gray-600">Intuitive UIs, die deine Mitarbeiter lieben werden</p>
                  </div>
                </li>
                
                <li className="flex items-start">
                  <div className="bg-blue-100 p-2 rounded-md mr-4">
                    <Database className="h-6 w-6 text-blue-700" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg">Nahtlose Integration</h4>
                    <p className="text-gray-600">Verbindung mit bestehenden Systemen und Datenquellen</p>
                  </div>
                </li>
                
                <li className="flex items-start">
                  <div className="bg-blue-100 p-2 rounded-md mr-4">
                    <Zap className="h-6 w-6 text-blue-700" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg">Automatisierte Arbeitsabläufe</h4>
                    <p className="text-gray-600">Reduzierung manueller Prozesse durch intelligente Automatisierung</p>
                  </div>
                </li>
                
                <li className="flex items-start">
                  <div className="bg-blue-100 p-2 rounded-md mr-4">
                    <Cloud className="h-6 w-6 text-blue-700" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg">Skalierbare Architektur</h4>
                    <p className="text-gray-600">Zukunftssicher und mit deinem Unternehmen mitwachsend</p>
                  </div>
                </li>
                
                <li className="flex items-start">
                  <div className="bg-purple-100 p-2 rounded-md mr-4">
                    <Cpu className="h-6 w-6 text-purple-700" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg">KI-gestützte Entwicklung</h4>
                    <p className="text-gray-600">Schnellere und kostengünstigere Softwareentwicklung durch KI-Innovationen</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceSection; 